import React from "react";
import PropTypes from "prop-types";
import { useFirestore } from 'react-redux-firebase';
import FormNewContact from './FormNewContact';

function NewContactForm(props){

  const firestore = useFirestore();

  function addContactToFirestore(event) {
    event.preventDefault();
    props.onNewContactCreation();

    return firestore.collection('contacts').add(
      {
        firstName: event.target.firstName.value,
        lastName: event.target.lastName.value,
        email: event.target.email.value,
        phoneNumber: event.target.phoneNumber.value,
        mailingStreetAddress: '',
        mailingCity: '',
        mailingRegion: '',
        mailingZipCode: '',
        mailingCountry: '',
        deliveryStreetAddress: '',
        deliveryCity: event.target.deliveryCity.value,
        deliveryRegion: event.target.deliveryRegion.value,
        deliveryZipCode: event.target.deliveryZipCode.value,
        deliveryCountry: event.target.deliveryCountry.value,
        contactType: 'inquiry',
        contactCompany: '',
        contactOccupation: '',
        contactAssociation: '',
        contactShow: "",
        description: '',
        createdTime: Date.now(),
        contactLand: '',
        contactContractor: '',
        contactFinancing: '',
        priorCustomer: ''
      }
    );
  }

  return (
    <React.Fragment>
      <FormNewContact 
      formSubmissionHandler = {addContactToFirestore}
      buttonText='submit' />
    </React.Fragment>
  );
}

NewContactForm.propTypes = {
  onNewContactCreation: PropTypes.func
};

export default NewContactForm;